import { useQuery } from "react-query";
import { getWeather, WeatherInfo } from "../../services/weatherAPI";

const REFRESH_MS = 15 * 60 * 1000;

export interface UseWeatherResult {
    weather: WeatherInfo | null;
    error: string | null;
}

export default function useWeather(
    lat: number | null | undefined,
    lng: number | null | undefined
): UseWeatherResult {
    const hasValidCoordinates =
        lat != null && lng != null && !(lat === 0 && lng === 0);

    const weatherQuery = useQuery({
        queryKey: ["weather", lat, lng],
        queryFn: () => getWeather(lat as number, lng as number),
        enabled: hasValidCoordinates,
        refetchInterval: REFRESH_MS,
        refetchOnWindowFocus: true,
        staleTime: REFRESH_MS,
    });

    return {
        weather: weatherQuery.data ?? null,
        error: weatherQuery.isError ? "Météo indisponible" : null,
    };
}
